import "./Header.css";
import Parse from "parse";
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Image,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import ShowLogoutAndSettings from "../ShowLogoutAndSettings";
import { Button, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import SidebarData from "../NavBar/SideBarData";
import { Link } from "react-router-dom";

let message = document.querySelector("#message");

function Header({ showImageHeader }) {
  const navigate = useNavigate();
  const [showAvatar, setShowAvatar] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const btnRef = React.useRef();

  const handleLogout = async (e) => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      Parse.User.logOut().then(() => {
        showImageHeader(false);
        setShowAvatar(false);
        navigate("/");
      });
    }
  };

  return (
    <>
      <header className="header">
        <div className="header_logo_title">
          <Box className="header_logo">
            <Image
              w={"fit-content"}
              h={"fit-content"}
              src={"/assets/images/recruteur2.png"}
              alt="logo"
            />
          </Box>
          <div className="header_title">
            <h1>HandyCatch</h1>
          </div>
        </div>
        <Box className="header_menu">
          <ul>
            <Box display={["block", "block", "none", "none"]}>
              {/* <li>
                <Link display={["block", "block", "none", "none"]} href="#">
                  <Image
                    display={["block", "block", "none", "none"]}
                    src={"/assets/images/Vector.png"}
                    alt="Messages"
                    id="message"
                  />
                </Link>
              </li>
              <li>
                <Link display={["block", "block", "none", "none"]} href="#">
                  <Image
                    display={["block", "block", "none", "none"]}
                    src={"/assets/images/notif.png"}
                    alt="Notifications"
                  />
                </Link>
              </li> */}
              <li>
                <Link
                  display={["block", "block", "none", "none"]}
                  ref={btnRef}
                  bg="teal"
                  href="#"
                >
                  <Image
                    display={["block", "block", "none", "none"]}
                    src={"/assets/images/menu.png"}
                    alt="menu"
                    onClick={() => setIsOpen(true)}
                  />
                </Link>
              </li>
            </Box>
            <li>
              {showAvatar ? (
                <Menu>
                  <MenuButton
                    me={"20px"}
                    display={["none", "none", "block", "block"]}
                  >
                    <ShowLogoutAndSettings showAvatar={showAvatar} />
                  </MenuButton>
                  <MenuList>
                    <MenuItem onClick={handleLogout}>Déconnexion</MenuItem>
                  </MenuList>
                </Menu>
              ) : (
                ""
              )}
            </li>
          </ul>
        </Box>
      </header>

      <Drawer
        display={["block", "block", "none", "none"]}
        isOpen={isOpen}
        placement="right"
        onClose={() => setIsOpen(false)}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton color={"white"} />
          <DrawerBody bgColor={"#0080FF"}>
            <Box marginTop={20}>
              <ul className="nav-menu-items">
                {SidebarData.map((item, index) => {
                  return (
                    <li key={index} className={item.cName}>
                      <Link to={item.path}>
                        {item.icon}
                        <span>{item.title}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default Header;
